import { render, staticRenderFns } from "./opRecord.vue?vue&type=template&id=089bfbbc&scoped=true&"
import script from "./opRecord.vue?vue&type=script&lang=js&"
export * from "./opRecord.vue?vue&type=script&lang=js&"
import style0 from "./opRecord.vue?vue&type=style&index=0&id=089bfbbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089bfbbc",
  null
  
)

export default component.exports